import { render, staticRenderFns } from "./limit-coupon-edit.vue?vue&type=template&id=0d509956&scoped=true"
import script from "./limit-coupon-edit.vue?vue&type=script&lang=js"
export * from "./limit-coupon-edit.vue?vue&type=script&lang=js"
import style0 from "./limit-coupon-edit.vue?vue&type=style&index=0&id=0d509956&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d509956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d509956')) {
      api.createRecord('0d509956', component.options)
    } else {
      api.reload('0d509956', component.options)
    }
    module.hot.accept("./limit-coupon-edit.vue?vue&type=template&id=0d509956&scoped=true", function () {
      api.rerender('0d509956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/activities/components/limit-coupon-edit.vue"
export default component.exports